import React, { useEffect } from "react";

export default function PropertyTypesOptions({
  register,
  fieldNamePrefix = "",
  setValue,
  watch,
  filterData,
  propertyCatsCounts,
}) {
  const fieldName = fieldNamePrefix
    ? `${fieldNamePrefix}_property_type`
    : "property_type";
  const selectedValues = filterData?.[`property_type`] || [];

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    let updatedValues = [...selectedValues];

    if (checked) {
      updatedValues.push(value);
    } else {
      updatedValues = updatedValues.filter((v) => v !== value);
    }

    setValue(fieldName, updatedValues);
    // If you want to update other fields too:
    setValue("property_type", updatedValues);
    setValue("polular_property_type", updatedValues);
    setValue("more_property_type", updatedValues);
  };

  return (
    <>
      {Object.entries(propertyCatsCounts).map(([key, count]) => (
        <div className="col-md-6" key={key}>
          <div className="lbl_btn">
            <input
              type="checkbox"
              name={fieldName}
              id={`${fieldName}_${key}`}
              value={key}
              checked={selectedValues.includes(key)}
              onChange={handleCheckboxChange}
            />
            <label htmlFor={`${fieldName}_${key}`}>
              <span>{key || "Unknown"}</span>
              <span>{count}</span>
            </label>
          </div>
        </div>
      ))}
    </>
  );
}
